import { render, staticRenderFns } from "./YwArtificialPatrolTaskList.vue?vue&type=template&id=746f207c&scoped=true&"
import script from "./YwArtificialPatrolTaskList.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolTaskList.vue?vue&type=script&lang=js&"
import style0 from "./YwArtificialPatrolTaskList.vue?vue&type=style&index=0&id=746f207c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746f207c",
  null
  
)

export default component.exports